import { useCallback, useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import API from "./API";
import { AdminPersonMonthReport, AdminQueryPerson, QueryActivities, QueryTimeReportRows, ReportingDataDay } from "../../backend/src/api/dto";
import { lookupMonthName } from "./global";
import { ModalContext } from './ModalContext';
import ModalAdminEditDayEntry from "./Modal/AdminEditDayEntry";
import DisplayTimeReportState from "./components/DisplayTimeReportState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DayAllocated } from "./interfaces";


function PersonMonthReport() {
    const params = useParams();

    const [loading, setLoading] = useState(false)
    const [currentData, setCurrentData] = useState<AdminPersonMonthReport>({
        daysInMonth: 0,
        month: 0,
        year: 0,
        timeReport: {
            timeReportId: 0,
            status: 0,
            approveDate: null,
            maxDayHours: 0,
            stdDayHours: 8,
            overtimeHours: 0,
            nonWorkingDayEntries: false
        },
        projects: [],
        loggedHours: [],
        days: [],
        workDays: 0,
        workHours: 0,
        activities: [],
        maxDayHours: 0,
        allocatedHours: 0,
        canBeClosed: false
    })
    const [person, setPerson] = useState<AdminQueryPerson | null>(null)
    const [showModal, closeModal] = useContext(ModalContext);
    const [dayAllocated, setDayAllocated] = useState<DayAllocated>({})

    useEffect(() => {
        setLoading(true)
        Promise.all([
            API.getPersonMonthReport(params.year ?? '', params.month ?? '', params.personId ?? ''),
            API.getPerson(params.personId ?? '')
        ]).then((data) => {
            setCurrentData(data[0])
            setPerson(data[1].person)
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        if (currentData.loggedHours) {
            setDayAllocated(
                currentData.loggedHours.reduce((acc: DayAllocated, item) => {
                    if (!acc[item.day]) {
                        acc[item.day] = 0;
                    }
                    acc[item.day] += item.hours ?? 0
                    return acc
                }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0, 17: 0, 18: 0, 19: 0, 20: 0, 21: 0, 22: 0, 23: 0, 24: 0, 25: 0, 26: 0, 27: 0, 28: 0, 29: 0, 30: 0, 31: 0 })
            );

        } else {
            setDayAllocated({});
        }
    }, [currentData])


    const getActivities = useCallback((item: QueryTimeReportRows) => {

        const loggedActivities = currentData?.loggedHours?.reduce((acc, entry) => {

            if (item.timeReportRowId === entry.timeReportRowId) {
                const found = currentData?.activities?.find((act) => act.activityId === entry.activityId);
                if (found) {
                    if (acc.findIndex(it => it.activityId === entry.activityId) === -1) {
                        acc.push(found)
                    }
                }
            }
            return acc

        }, [] as QueryActivities[])

        return loggedActivities?.length ? loggedActivities : [{ activityId: 0, name: '' }]
    }, [currentData])

    const getLoggedHour = useCallback((timeReportRowId: number, day: number, withActivities: boolean = false, activity?: any) => {
        if (!currentData || !currentData.loggedHours) {
            return {
                hours: null,
                activityId: activity.activityId
            }
        }
        const foundItem = currentData.loggedHours.find(item => {
            if (withActivities) {
                return item.day === day && item.timeReportRowId === timeReportRowId && item.activityId === activity.activityId
            } else {
                return item.day === day && item.timeReportRowId === timeReportRowId
            }
        })
        if (foundItem) {
            return {
                hours: foundItem.hours,
                activityId: foundItem.activityId
            }
        }
        return {
            hours: null,
            activityId: activity.activityId
        }
    }, [currentData])


    const updateEntry = (day: number, timeReportRowId: number, hours: number, timeReportEntryId: number, activityId: number) => {
        setCurrentData(prevData => {
            // if (!prevData) {
            //     return null
            // }
            return {
                ...prevData,
                loggedHours: prevData && prevData.loggedHours ? (prevData.loggedHours.find((item) => {
                    return (item.timeReportRowId === timeReportRowId && item.day === day && item.activityId === activityId)
                }) ? prevData.loggedHours.map((item) => {
                    if (item.timeReportRowId === timeReportRowId && item.day === day && item.activityId === activityId) {
                        item.hours = hours
                    }
                    return item
                }) : [...prevData.loggedHours, {
                    day,
                    timeReportRowId,
                    hours,
                    timeReportEntryId,
                    activityId, ///////////////////////////////////////
                }]) : []
            }
        })

    }

    const deleteEntry = (day: number, timeReportRowId: number, activityId: number) => {
        setCurrentData(prevData => {
            // if (!prevData) {
            //     return null
            // }
            return {
                ...prevData,
                loggedHours: prevData && prevData.loggedHours ? (prevData.loggedHours.filter((item) => {
                    return !(item.timeReportRowId === timeReportRowId && item.day === day && item.activityId === activityId)
                })) : []
            }
        })
    }


    const createReport = () => {
        setLoading(true)
        API.createPersonMonthReport(params.year ?? '', params.month ?? '', params.personId ?? '').then((data) => {
            setCurrentData(data)
            setLoading(false)
        })
    }

    const setTimeReportStatus = (status: number) => {
        API.setPersonMonthReport(params.year ?? '', params.month ?? '', params.personId ?? '', status).then((data) => {
            setCurrentData(data)
            setLoading(false)
        })
    }


    const getRowLoggedHours = useCallback((timeReportRowId: number, activityId: number) => {
        return (currentData.loggedHours ?? []).reduce((acc, item) => {
            if (item.timeReportRowId === timeReportRowId && item.activityId === activityId) {
                acc += item.hours
            }
            return acc
        }, 0)
    }, [currentData])



    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>

                        <div className="row">
                            <div className="col-1">
                                <span className=""><Link to="/dashboard/reporting" className="btn btn-primary">Späť</Link></span>
                            </div>
                            <div className="col-6 mt-2  ">
                                <span className="me-5">Rok: ...</span>
                                <span className="me-5">Mesiac: ...</span>
                                <span className=" ">Osoba: ...</span>
                            </div>
                            <div className="col-1 mt-2">Stav: ...</div>
                            <div className="col-4 text-end">

                            </div>
                        </div>


                    </div>
                    <div className="card-body">Nahrávam</div>


                </div>
            </div>
        )
    }


    if (!currentData) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>

                        <div className="row">
                            <div className="col-1">
                                <span className=""><Link to="/dashboard/reporting" className="btn btn-primary">Späť</Link></span>
                            </div>
                            <div className="col-6 mt-2  ">
                                <span className="me-5">Rok: <strong>{params.year}</strong></span>
                                <span className="me-5">Mesiac: <strong>{params.month}. <small>({lookupMonthName(params.month)})</small></strong></span>
                                <span className=" ">Osoba: <strong>{person?.name} {person?.surname}</strong></span>
                            </div>
                            <div className="col-1 mt-2">Stav: <DisplayTimeReportState state={null} /></div>
                            <div className="col-4 text-end">
                                <button onClick={createReport} className="btn btn-success">Vytvoriť</button>
                            </div>
                        </div>


                    </div>
                    <div className="card-body">Time report pre tohto užívateľa pre tento mesiac ešte nebol vytvorený</div>



                    {
                        person ?
                            <div className="row mt-5">
                                <div className="col-4">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th colSpan={2} className="text-center bg-cyan">Globálne nastavenia užívateľa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Max hodín na deň</td>
                                                <td>{person.maxDayHours}</td>
                                            </tr>
                                            <tr>
                                                <td>Štandartne hodín na deň</td>
                                                <td>{person.stdDayHours}</td>
                                            </tr>
                                            <tr>
                                                <td>Nadčasy</td>
                                                <td>{person.monthOvertimeHours ? 'Áno' : 'Nie'}</td>
                                            </tr>
                                            <tr>
                                                <td>Alokácie v nepracovné dni</td>
                                                <td>{person.nonWorkingDayEntries ? 'Áno' : 'Nie'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null
                    }


                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>

                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/reporting" className="btn btn-primary">Späť</Link></span>
                        </div>
                        <div className="col-6 mt-2  ">
                            <span className="me-5">Rok: <strong>{params.year}</strong></span>
                            <span className="me-5">Mesiac: <strong>{params.month}. <small>({lookupMonthName(params.month)})</small></strong></span>
                            <span className=" ">Osoba: <strong>{person?.name} {person?.surname}</strong></span>
                        </div>
                        <div className="col-2 mt-2">Stav: <DisplayTimeReportState state={currentData.timeReport?.status} /></div>
                        <div className="col-3 text-end">
                            {
                                currentData.timeReport?.status === 0 ?
                                    currentData.canBeClosed ?
                                        <>
                                            <button onClick={() => setTimeReportStatus(2)} className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "check"]} /> Uzavrieť</button>
                                        </>
                                        :
                                        <>
                                            <button  className="btn btn-secondary" title="Nie je možné uzavrieť pretože nie sú potvrdené všetky pojekty projekt manažérmi"><FontAwesomeIcon fixedWidth icon={["fas", "xmark"]} /> Nie je možné uzavrieť</button>
                                        </>
                                    : currentData.timeReport?.status === 1 ? <>
                                        <button onClick={() => setTimeReportStatus(2)} className="btn btn-success me-5"><FontAwesomeIcon fixedWidth icon={["fas", "check"]} /> Uzavrieť</button>
                                        <button onClick={() => setTimeReportStatus(0)} className="btn btn-danger"><FontAwesomeIcon fixedWidth icon={["fas", "rotate-left"]} /> Vrátiť</button>
                                    </> : currentData.timeReport?.status === 2 ? <>
                                        <button onClick={() => setTimeReportStatus(3)} className="btn btn-primary me-5"><FontAwesomeIcon fixedWidth icon={["fas", "lock"]} /> Uzamknúť</button>
                                        <button onClick={() => setTimeReportStatus(0)} className="btn btn-warning"><FontAwesomeIcon fixedWidth icon={["fas", "rotate-left"]} /> Otvoriť</button>
                                    </> : currentData.timeReport?.status === 3 ? null : <>
                                        <div>?</div>
                                    </>
                            }


                        </div>
                    </div>


                </div>
                <div className="card-body">
                    {
                        currentData.days && currentData.projects ?
                            <table className="table table-bordered table-condensed">
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: '12px' }}>Projekt</th>
                                        <th style={{ fontSize: '12px' }}>Komponent</th>
                                        <th style={{ fontSize: '12px' }} className="border-right">Aktivita</th>
                                        {
                                            currentData.days.map((day, index) => {
                                                let classes = ['text-center'];


                                                if (day.dayType === 1 || day.dayType === 2) {
                                                    classes.push('text-danger bg-light-pink');
                                                }


                                                return (
                                                    <th role="button" className={classes.join(' ')} style={{ fontSize: '12px', width: '25px' }}>{index + 1}</th>
                                                )

                                            })

                                        }
                                        <th className="text-center" style={{ fontSize: '12px', width: '40px', maxWidth: '40px' }}>Sumár</th>
                                        <th className="text-center" style={{ fontSize: '12px', width: '20px', maxWidth: '20px' }}>Info</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {
                                        currentData.projects.map((item) => {

                                            const activities = item.withActivities ? getActivities(item) : [{ activityId: 0, name: '' }];

                                            return (
                                                <>
                                                    {
                                                        activities.map((activity: any, index: number) => {
                                                            const rowLoggedHours = getRowLoggedHours(item.timeReportRowId, activity.activityId)
                                                            return (
                                                                <tr>
                                                                    {
                                                                        index === 0 ?
                                                                            <>
                                                                                <td style={{ fontSize: '12px', width: '60px' }} rowSpan={activities.length}>{item.projectName}</td>
                                                                                <td style={{ fontSize: '12px', width: '60px' }} rowSpan={activities.length}>{item.orderName}</td>
                                                                            </>
                                                                            : null
                                                                    }

                                                                    <td style={{ fontSize: '12px', width: '60px' }} className="border-right">{activity.name}</td>
                                                                    {
                                                                        currentData.days?.map((day, index) => {
                                                                            const hours = getLoggedHour(item.timeReportRowId, day.day, item.withActivities, activity) ?? null;
                                                                            let classes = ['text-center reporting-entry'];





                                                                            if (!currentData.timeReport?.nonWorkingDayEntries && day.dayType !== 0) {
                                                                                return (
                                                                                    <td className="bg-light-pink"></td>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <td role="button" className={classes.join(' ')} style={{ fontSize: '12px', }}
                                                                                        onClick={
                                                                                            () => showModal(
                                                                                                <ModalAdminEditDayEntry
                                                                                                    item={item}
                                                                                                    day={day}
                                                                                                    hours={hours}
                                                                                                    activities={activities}
                                                                                                    currentData={currentData}
                                                                                                    updateEntry={updateEntry}
                                                                                                    deleteEntry={deleteEntry}
                                                                                                />
                                                                                            )
                                                                                        }
                                                                                    >{hours.hours}</td>
                                                                                )
                                                                            }

                                                                        })
                                                                    }
                                                                    {
                                                                        index === 0 ?
                                                                            <>
                                                                                <td className="text-center" style={{ fontSize: '12px', width: '40px', maxWidth: '40px' }} rowSpan={activities.length}>
                                                                                    {rowLoggedHours}
                                                                                </td>
                                                                                <td className="text-center" rowSpan={activities.length}>
                                                                                    {
                                                                                        item.extraApproval ?
                                                                                            item.pmApproved ?
                                                                                                <FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} className="text-success" title="Schálené projektovým manažérom" />
                                                                                                : <FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} className="text-danger" title="Ešte nebolo schálené projektovým manažérom" />
                                                                                            : <FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} className="text-secondary" title="Projekt nevyžaduje schvalovanie projektovým manažérom" />
                                                                                    }



                                                                                </td>
                                                                            </>

                                                                            : null
                                                                    }
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </>
                                            )
                                        })
                                    }

                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td style={{ fontSize: '12px' }} className="text-center border-right" colSpan={3}>CELKOVO ALOKOVANÉ</td>
                                        {
                                            currentData.days.map((day, index) => {
                                                return (
                                                    <td className="text-center fw-bold" style={{ fontSize: '12px' }}><AllocationStatus currentData={currentData} dayAllocated={dayAllocated} day={day} /></td>
                                                )

                                            })
                                        }
                                        <td className="text-center" style={{ fontSize: '12px', width: '40px', maxWidth: '40px' }}>{currentData.allocatedHours}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                            : null
                    }

                </div>
            </div>

            {
                currentData.timeReport && person ?

                    <div className="row mt-5">
                        <div className="col-4">

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="text-center bg-cyan">Nastavenia</th>
                                        <th className="text-center bg-cyan">Tento mesiac</th>
                                        <th className="text-center bg-cyan">Globálne</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Maximum hodín na deň</td>
                                        <td className="text-center">{currentData.timeReport.maxDayHours}</td>
                                        <td className="text-center">{person.maxDayHours}</td>
                                    </tr>
                                    <tr>
                                        <td>Štandartne hodín na deň</td>
                                        <td className="text-center">{currentData.timeReport.stdDayHours}</td>
                                        <td className="text-center">{person.stdDayHours}</td>
                                    </tr>
                                    <tr>
                                        <td>Nadčasy</td>
                                        <td className="text-center">{currentData.timeReport.overtimeHours ? 'Áno' : 'Nie'}</td>
                                        <td className="text-center">{person.monthOvertimeHours ? 'Áno' : 'Nie'}</td>
                                    </tr>
                                    <tr>
                                        <td>Alokácie v nepracovné dni</td>
                                        <td className="text-center">{currentData.timeReport.nonWorkingDayEntries ? 'Áno' : 'Nie'}</td>
                                        <td className="text-center">{person.nonWorkingDayEntries ? 'Áno' : 'Nie'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                    : null
            }



        </div>
    )
}


function AllocationStatus({ currentData, dayAllocated, day }: { currentData: AdminPersonMonthReport, dayAllocated: DayAllocated, day: ReportingDataDay }) {
    if (day.dayType === 0) {
        let classes = [];
        if (currentData.timeReport?.stdDayHours === dayAllocated[day.day]) {
            classes.push('text-success');
        } else if ((currentData.timeReport?.stdDayHours ?? 0) < dayAllocated[day.day]) {
            classes.push('text-warning');
        } else {
            classes.push('text-danger')
        }

        return (
            <span className={classes.join(' ')}>{dayAllocated[day.day]}</span>
        )
    } else {
        return null
    }
}


export default PersonMonthReport